import axios from "axios";
import React, { useState, useEffect } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { APIURL } from "../Config";
import moment from "moment";
import LoanDetails from "./LoanDetails";
import SweetAlert from "react-bootstrap-sweetalert";
import { useLocation } from "react-router-dom";

function EmpOutstandingSummary() {
  const token = localStorage.getItem("token");
  const cid = localStorage.getItem("corporateId");
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [empSummary, setEmpSummary] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [paymentCallback, setPaymentCallback] = useState("");
  const [paymentRespons, setPaymentRespons] = useState("");

  console.log("paymentCallback", paymentCallback);
  const [isLoader, setIsLoader] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [amountPay, setAmountPay] = useState({});
  const [totalUnpaid, setTotalUnpaid] = useState(0);
  const tableEmpSummaryModel = React.useRef(null);
  const tableEmpOutstanding = React.useRef(null);
  const [manageEmpStatus, setManageEmpStatus] = useState(true);
  const [apiKey, setApiKey] = useState("");
  const [alert, setAlert] = useState(null);
  const [flag, setFlag] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(false);
  console.log("psss:", paymentStatus);
  console.log("amount:::::", totalUnpaid);

  const currentDate = moment().date();
  const endOfMonth = moment().endOf("month").date();

  const [selectedData, setSelectedData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const ONE_HOUR_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds

  const STORAGE_KEY = "Time";

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("Time"));
    if (
      storedData === "undefined" ||
      storedData === "" ||
      !storedData ||
      storedData === "null"
    ) {
      console.log("storeData:::", storedData);
    } else {
      setShowMessage(true);
    }
  }, []);
  // Function to check if the key has expired
  const isKeyExpired = () => {
    const storedData = JSON.parse(localStorage.getItem("Time"));
    if (storedData) {
      const { timestamp } = storedData;
      const currentTime = new Date().getTime();
      return currentTime - timestamp > ONE_HOUR_IN_MS;
    }
    return false;
  };

  // Function to remove key if expired
  const removeExpiredKey = () => {
    if (isKeyExpired()) {
      localStorage.removeItem(STORAGE_KEY);
      setShowMessage(false);
      console.log("remove from local storage", STORAGE_KEY);
    }
  };

  const handlePaymentInterval = () => {
    const interval = setInterval(() => {
      const storedData = JSON.parse(localStorage.getItem("Time"));
      console.log("storedata:::::", storedData);
      const time = storedData?.timestamp;
      console.log("Initial time from localStorage:::", time);
      console.log("payment response:::", paymentRespons);

      if (
        (paymentRespons && storedData === "undefined") ||
        storedData === "" ||
        !storedData ||
        storedData === "null"
      ) {
        console.log("payment response111111:::", paymentRespons);

        const currentTime = new Date().getTime();
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ timestamp: currentTime })
        );

        // Fetch the updated time from localStorage after setting it
        const updatedStoredData = JSON.parse(localStorage.getItem(STORAGE_KEY));
        const updatedTime = updatedStoredData?.timestamp;

        console.log("Payment successful. Time set in localStorage.");
        console.log("Updated time from localStorage:::", updatedTime); // Log the updated time

        clearInterval(interval); // Clear the interval after setting the time
      }
    }, 1000);

    // Clear the interval on component unmount to avoid memory leaks
    return () => clearInterval(interval);
  };

  useEffect(() => {
    const expirationInterval = setInterval(() => {
      removeExpiredKey();
    }, 2000);
    return () => clearInterval(expirationInterval);
  }, []);

  // const canMakePayment = () => {
  //   return !isKeyExpired();
  // };

  console.log("show mwssagw", showMessage);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedData(empData);
      setSelectAll(true);
      console.log("All data selected:", empData);
    } else {
      setSelectedData([]);
      setSelectAll(false);
      console.log("All data deselected");
    }
  };
  const handleRowSelect = (item) => {
    setSelectedData((prevSelectedData) => {
      const isSelected = prevSelectedData.find(
        (data) => data.loanid === item.loanid
      );

      if (isSelected) {
        // Item is already selected, remove it
        const newData = prevSelectedData.filter(
          (data) => data.loanid !== item.loanid
        );
        console.log("Removed:", newData);

        // If no items are selected, uncheck selectAll
        if (newData.length === 0) {
          setSelectAll(false);
        }

        return newData;
      } else {
        // Item is not selected, add it
        const newData = [...prevSelectedData, item];
        console.log("Added:", newData);

        // If all items are selected, check selectAll
        if (newData.length === empData.length) {
          setSelectAll(true);
        }

        return newData;
      }
    });
  };

  const isAllSelected = selectedData.length === empData.length; // Dynamically determine if all are selected

  useEffect(() => {
    if (apiKey === "getSummaryUnpaid" || apiKey === "getSummaryoutstanding") {
      // Calculate total unpaid amount whenever selectedData changes
      const total = selectedData.reduce(
        (acc, curr) => acc + (curr.amount || 0),
        0
      );

      setTotalUnpaid(total.toFixed(2)); // Update the state with calculated total
    }
  }, [selectedData, apiKey]);

  useEffect(() => {
    console.log("abx");
    setSelectedData([]);
    setSelectAll(false);
  }, []);

  useEffect(() => {
    setManageEmpStatus(false);
    getEnachSummaryModel();
  }, []);

  useEffect(() => {
    setTotalUnpaid(0);
  }, []);

  useEffect(() => {
    let intervalId;
    console.log("flag::", flag);
    const getReturnCallback = () => {
      setIsLoader(true);
      axios
        .request(`${APIURL}/returnCallBack/${cid}`, {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("rp:", response.data);
          if (response.data.message == "Your payment is successful.") {
            setPaymentCallback({ ...response.data });
            PopUp(response.data);
            PopUp(response.data);
            getAllUpdatePaymentList(empData, totalUnpaid, 1);
            console.log("successs::::", response.data);
            setPaymentStatus(false);
            setFlag(false);
          }

          if (response.data.code == "Payment Failed") {
            setPaymentCallback({ ...response.data });
            PopUp(response.data);
            PopUp(response.data);
            console.log("successs::::", response.data);
            setPaymentStatus(false);
            setFlag(false);
          }
          setIsLoader(false);

          console.log("response", response);
        })
        .catch((error) => {
          console.log("error", error);
          setIsLoader(false);
        });
    };

    if (flag) {
      // Start the interval if flag is true
      intervalId = setInterval(() => {
        getReturnCallback();
      }, 10000); // Call every 10 seconds
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [flag]);

  const getEnachSummaryModel = () => {
    // const data = { email: email, status: month };
    setIsLoader(true);
    axios
      .request(`${APIURL}/getEnachSummaryModel/${cid}/0`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setEmpSummary(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const payment = (amount) => {
    setIsLoader(true);
    let data = {
      loanid: cid,
      paymenttype: 12,
      amount: amount,
    };
    console.log("first", totalUnpaid);
    axios
      .request(`${APIURL}/checksomepaypages`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: "Basic ODI3OTg0ODkyOToxMDE1",
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        setIsLoader(false);
        setPaymentRespons(response);
        console.log("response payment list::::", paymentRespons);
        const { url } = response.data.data.instrumentResponse.redirectInfo;
        if (url) {
          window.open(url, "_blank");
        } else {
          console.error("URL not found in response");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const getAllUpdatePaymentList = (value, amount, status) => {
    setIsLoader(true);
    PopUp("");

    const selectedItems = selectedData;

    console.log("selected items for payment::::", selectedItems);

    const transformedData = (
      selectedItems.length > 0 ? selectedItems : value
    ).map((item) => ({
      appid: item.appid,
      name: item.name,
      mobile: item.mobileno,
      loanid: item.loanid,
      stage1: item.stage1,
      amount: item.amount,
      txndate: item.txndate,
      code: item.code,
      instno: item.instno,
      cropid: cid,
      paymentstatus: status,
    }));

    // const transformedData = value.map((item) => ({
    //   appid: item.appid,
    //   name: item.name,
    //   mobile: item.mobileno,
    //   loanid: item.loanid,
    //   stage1: item.stage1,
    //   amount: item.amount,
    //   txndate: item.txndate,
    //   code: item.code,
    //   instno: item.instno,
    //   cropid: cid,
    // }));

    axios
      .request(`${APIURL}/saveAllUpdatepaymentlist`, {
        method: "POST",
        data: transformedData,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response payment list::::", response);
        if (status == 2) {
          payment(amount);
        }
        ManageEmpSummary("getSummaryoutstanding", 1);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const PopUp = (status) => {
    console.log("status", status);
    setAlert(
      status === "" ? (
        <SweetAlert
          warning
          style={{ display: "block" }}
          onConfirm={() => {
            setAlert(null);
            setFlag(false);
          }}
          confirmBtnText="Cancel"
          confirmBtnStyle={{ backgroundColor: "#6c757d", border: "none" }}
        >
          <h3 style={{ color: "black" }}>Payment Request is Created</h3>{" "}
          <div className="text-center" style={{ margin: "20px 0" }}>
            <div className="spinner-border text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p style={{ marginTop: "10px", color: "black" }}>
              Please complete your payment.
            </p>
          </div>
        </SweetAlert>
      ) : (
        <div>
          {console.log("payment callback::::", paymentCallback)}
          {status?.message == "Your payment is successful." && (
            <SweetAlert
              success
              style={{ display: "block" }}
              onConfirm={() => {
                setAlert(null);
                setFlag(false);
              }}
              confirmBtnStyle={{ backgroundColor: "#66a725", border: "none" }}
            >
              <h1 style={{ color: "#66a725" }}>Payment Successful</h1>

              <div
                className="card shadow-sm"
                style={{
                  borderRadius: "8px",
                  padding: "8px",
                  maxWidth: "400px",
                  margin: "15px auto",
                  border: "grey",
                }}
              >
                <div className="card-body text-center">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontSize: "14px", color: "#6c757d" }}>
                      Amount
                    </span>
                    <span
                      className="my-auto"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{status?.data?.amount}
                    </span>
                  </div>
                  <hr />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span
                      className="mt-1"
                      style={{ fontSize: "14px", color: "#6c757d" }}
                    >
                      Transaction ID
                    </span>
                    <span
                      className="my-auto"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      {status?.data?.transactionId}
                    </span>

                    <b>
                      You may re-upload the employee mobile numbers and limits;
                      otherwise, the existing limits will remain unchanged.
                    </b>
                  </div>
                </div>
              </div>
            </SweetAlert>
          )}
          {status?.code == "Payment Failed" && (
            <SweetAlert
              danger
              style={{ display: "block" }}
              onConfirm={() => {
                setAlert(null);
                setFlag(false);
              }}
              confirmBtnStyle={{ backgroundColor: "#d9534f", border: "none" }}
            >
              <h1 style={{ color: "#d9534f" }}>Payment Failed</h1>

              <div
                className="card shadow-sm"
                style={{
                  borderRadius: "8px",
                  padding: "8px",
                  maxWidth: "400px",
                  margin: "15px auto",
                  border: "grey",
                }}
              >
                <div className="card-body text-center">
                  <div
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ fontSize: "14px", color: "#6c757d" }}>
                      Amount
                    </span>
                    <span
                      className="my-auto"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      ₹{status?.data?.amount}
                    </span>
                  </div>
                  <hr />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span
                      className="mt-1"
                      style={{ fontSize: "14px", color: "#6c757d" }}
                    >
                      Transaction ID
                    </span>
                    <span
                      className="my-auto"
                      style={{
                        fontSize: "16px",
                        color: "black",
                        fontWeight: "bold",
                      }}
                    >
                      {status?.data?.transactionId}
                    </span>
                  </div>
                </div>
              </div>

              {/* Retry and Cancel buttons */}
            </SweetAlert>
          )}
        </div>
      )
    );
  };

  const ManageEmpSummary = (key, status) => {
    let sAmount = [];
    setIsLoader(true);
    axios
      .request(`${APIURL}/${key}/${cid}/${status}/0`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);
        response.data.map((row, index) => {
          sAmount.push(row.amount);
        });
        const total = sAmount.reduce((a, b) => a + b, 0);
        setTotalUnpaid(total.toFixed(2));
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const ManageEmpSummaryPayAmount = (key, status, amount) => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/${key}/${cid}/${status}/0`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);
        setTotalUnpaid(amount);
        getAllUpdatePaymentList(response?.data, amount, 2);
        setFlag(true);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className="pt-3">
      <div className="card">
        {alert}
        {showSearch ? (
          <>
            <div className="p-3 d-flex justify-content-start mt-3">
              <button
                className="btn btn-secondary"
                style={{ width: "100px" }}
                onClick={() => {
                  setShowSearch(false);
                }}
              >
                Back
              </button>
            </div>
            <div className="p-3 pt-2">
              <LoanDetails lid={lid} />
            </div>
          </>
        ) : (
          <>
            <div className="p-3 pt-4">
              {!manageEmpStatus && (
                <>
                  <div className="d-flex justify-content-start align-items-center">
                    <div>
                      <DownloadTableExcel
                        filename="EmpOutstandingSummary"
                        sheet="users"
                        currentTableRef={tableEmpSummaryModel.current}
                      >
                        <button
                          className="btn btn-success"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          Download
                        </button>
                      </DownloadTableExcel>
                    </div>
                    {/* <div className="mt-2 mt-md-0 d-flex align-items-start align-items-md-center">
              <select
                className="form-select mx-0 mx-md-2 mb-2 mb-md-0 w-auto"
                id="lang"
                onChange={(e) => setMonth(e.target.value)}
                value={month}
              >
                {months.map(({ name, value }) => (
                  <option key={value} value={value}>
                    {name}
                  </option>
                ))}
              </select>
              <button
                className="btn btn-success border ml-md-2"
                style={{ background: "#66a725", color: "#fff" }}
                onClick={outstandingList}
              >
                {isLoader ? (
                  <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "Search"
                )}
              </button>
            </div> */}
                  </div>
                  <div className="table-responsive">
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Due Month</th>
                          <th style={{ textAlign: "center" }}>Due Case</th>
                          <th style={{ textAlign: "center" }}>Due Amount</th>
                          {/* <th style={{ textAlign: "center" }}>
                            Today Collection
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Collection Count
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Collection Amt
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Outstanding Count
                          </th> */}
                          <th style={{ textAlign: "center" }}>
                            Outstanding Amt (1-7th of the month)
                          </th>
                          {/* <th style={{ textAlign: "center" }}>
                            Late Fee Amount
                          </th>
                          <th style={{ textAlign: "center" }}>Unpaid</th>
                          <th style={{ textAlign: "center" }}>
                            Unpaid Amt (Post 7th of the month)
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {empSummary.length > 0 ? (
                          empSummary.map((item, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.due_month}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.due_case}
                              </td>
                              <td
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.due_case) {
                                    setManageEmpStatus(true);
                                    ManageEmpSummary("getSummaryDueCase", i);
                                    setApiKey("getSummaryDueCase");
                                  }
                                }}
                              >
                                {item.due}
                              </td>
                              {/* <td style={{ textAlign: "center" }}>
                                {item.todaycollection}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.collectionc}
                              </td>
                              <td
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.due_case) {
                                    setManageEmpStatus(true);
                                    ManageEmpSummary(
                                      "geSummaryCollectionTodayMonth",
                                      i
                                    );
                                    setApiKey("geSummaryCollectionTodayMonth");
                                  }
                                }}
                              >
                                {item.coll}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.outstandingcase}
                              </td> */}
                              <td
                                style={{
                                  color: "red",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.outstandingamount) {
                                    setManageEmpStatus(true);
                                    ManageEmpSummary(
                                      "getSummaryoutstanding",
                                      i
                                    );
                                    setApiKey("getSummaryoutstanding");
                                  }
                                }}
                              >
                                {item.outstandingamount}
                                <br />

                                {item.outstandingamount != 0 && (
                                  // Conditionally render the button
                                  <>
                                    <button
                                      className="btn btn-success w-auto"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent the row click event when button is clicked
                                        ManageEmpSummaryPayAmount(
                                          "getSummaryoutstanding",
                                          i,
                                          item?.outstandingamount
                                        );
                                        setTotalUnpaid(item?.outstandingamount);
                                        setShowMessage(true);
                                        handlePaymentInterval();
                                      }}
                                      // disabled={showMessage}
                                    >
                                      Pay Now
                                    </button>
                                    {/* {showMessage && (
                                      <div className="text-muted mt-1">
                                        Make payment after 1 hour
                                      </div>
                                    )} */}
                                  </>
                                )}
                              </td>
                              {/* <td
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.latefee) {
                                    setManageEmpStatus(true);
                                    ManageEmpSummary("getSummarylatefee", i);
                                    setApiKey("getSummarylatefee");
                                  }
                                }}
                              >
                                {item?.latefee || 0}
                              </td>

                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {item.unpaid}
                              </td>
                              <td
                                style={{
                                  color: "red",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.unpaidamount) {
                                    setManageEmpStatus(true);
                                    ManageEmpSummary("getSummaryUnpaid", i);
                                    setApiKey("getSummaryUnpaid");
                                  }
                                }}
                              >
                                {item.unpaidamount}

                                {item.unpaidamount > 0 && ( // Conditionally render the button
                                  <>
                                    <button
                                      className="btn btn-danger text-white py-2 px-4 rounded shadow"
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevent row click when "Pay Now" is clicked
                                        ManageEmpSummaryPayAmount(
                                          "getSummaryUnpaid",
                                          i,
                                          item?.unpaidamount
                                        );
                                        setTotalUnpaid(item?.unpaidamount);
                                        setShowMessage(true);
                                        handlePaymentInterval();
                                      }}
                                      disabled={showMessage}
                                    >
                                      Pay Now
                                    </button>
                                    {showMessage && (
                                      <div className="text-muted mt-1">
                                        Make payment after 1 hour
                                      </div>
                                    )}
                                  </>
                                )}
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" style={{ textAlign: "center" }}>
                              {isLoader ? (
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "No data available"
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {manageEmpStatus && (
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    {/* Left side buttons */}
                    <div className="d-flex">
                      <DownloadTableExcel
                        filename="EmpOutstandingSummary"
                        sheet="users"
                        currentTableRef={tableEmpOutstanding.current}
                      >
                        <button
                          className="btn btn-success mb-0 mb-md-0 mt-0 mr-3"
                          style={{
                            width: "120px",
                            backgroundColor: "#66a725",
                          }}
                        >
                          Download
                        </button>
                      </DownloadTableExcel>

                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          setManageEmpStatus(false);
                          setSelectedData([]);
                          setSelectAll(false);
                        }}
                        style={{ width: "80px" }}
                      >
                        Back
                      </button>
                    </div>

                    {/* Right side content */}

                    <div className="d-flex">
                      {apiKey === "getSummaryUnpaid" && (
                        <>
                          <div className="d-flex align-items-center">
                            <p className="mb-0 font-weight-bold">
                              Total Unpaid Amount:{" "}
                              {selectedData
                                .reduce(
                                  (acc, curr) => acc + (curr.amount || 0),
                                  0
                                )
                                .toFixed(2)}
                            </p>
                          </div>
                          <div>
                            <button
                              className="btn btn-success w-auto ml-2"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the row click event when button is clicked
                                ManageEmpSummaryPayAmount(
                                  "getSummaryUnpaid",
                                  0,
                                  totalUnpaid
                                );
                                setTotalUnpaid(totalUnpaid);
                                setShowMessage(true);
                                handlePaymentInterval();
                              }}
                              disabled={showMessage}
                            >
                              Pay Now
                            </button>
                            {showMessage && (
                              <div className="text-muted mt-1">
                                Make payment after 1 hour
                              </div>
                            )}
                          </div>
                        </>
                      )}
                      {apiKey === "getSummaryoutstanding" && (
                        <>
                          <div className="d-flex align-items-center">
                            <p className="mb-0 font-weight-bold">
                              Total OutStanding Amount:{" "}
                              {selectedData
                                .reduce(
                                  (acc, curr) => acc + (curr.amount || 0),
                                  0
                                )
                                .toFixed(2)}
                            </p>
                          </div>
                          <div>
                            <button
                              className="btn btn-success w-auto ml-2"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the row click event when button is clicked
                                ManageEmpSummaryPayAmount(
                                  "getSummaryoutstanding",
                                  0,
                                  totalUnpaid
                                );
                                setTotalUnpaid(totalUnpaid);
                                setShowMessage(true);
                                handlePaymentInterval();
                              }}
                              // disabled={showMessage}
                            >
                              Pay Now
                            </button>
                            {/* {showMessage && (
                              <div className="text-muted mt-1">
                                Make payment after 1 hour
                              </div>
                            )} */}
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-striped mt-3">
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th>Name</th>
                          <th style={{ textAlign: "center" }}>Loan Id</th>
                          <th>Employer Name</th>
                          <th style={{ textAlign: "center" }}>Mobile No</th>

                          {apiKey === "getSummaryDueCase" && (
                            <th style={{ textAlign: "center" }}>Due Date</th>
                          )}
                          {apiKey === "geSummaryCollectionTodayMonth" && (
                            <th style={{ textAlign: "center" }}>
                              Collection Date
                            </th>
                          )}
                          {apiKey === "getSummaryoutstanding" && (
                            <th style={{ textAlign: "center" }}>
                              Outstanding Date
                            </th>
                          )}
                          {apiKey === "getSummaryUnpaid" && (
                            <th style={{ textAlign: "center" }}>Unpaid Date</th>
                          )}

                          {apiKey === "getSummarylatefee" && (
                            <th style={{ textAlign: "center" }}>
                              Late Fee Date
                            </th>
                          )}
                          {apiKey === "getSummaryDueCase" && (
                            <th style={{ textAlign: "center" }}>Due Amount</th>
                          )}
                          {apiKey === "geSummaryCollectionTodayMonth" && (
                            <th style={{ textAlign: "center" }}>
                              Collection Amount
                            </th>
                          )}
                          {apiKey === "getSummaryoutstanding" && (
                            <th style={{ textAlign: "center" }}>
                              Outstanding Amount
                            </th>
                          )}
                          {apiKey === "getSummaryUnpaid" && (
                            <th style={{ textAlign: "center" }}>
                              Unpaid Amount
                            </th>
                          )}
                          {apiKey === "getSummarylatefee" && (
                            <th style={{ textAlign: "center" }}>
                              Late Fee Amount
                            </th>
                          )}

                          {apiKey === "getSummaryUnpaid" ||
                            (apiKey === "getSummaryoutstanding" && (
                              <th style={{ textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />
                              </th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {empData.length > 0 ? (
                          empData.map((item, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>

                              <td>{item.name}</td>

                              <td
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.loanid) {
                                    setLid(item.loanid);
                                    setShowSearch(true);
                                  }
                                }}
                              >
                                {item.loanid}
                              </td>
                              <td>{item.code}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.mobileno}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {moment(item.txndate).format("DD-MM-YYYY")}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.amount}
                              </td>

                              {apiKey === "getSummaryUnpaid" ||
                                (apiKey === "getSummaryoutstanding" && (
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      checked={
                                        !!selectedData.find(
                                          (data) => data.loanid === item.loanid
                                        )
                                      }
                                      onChange={() => handleRowSelect(item)}
                                    />
                                  </td>
                                ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" style={{ textAlign: "center" }}>
                              {isLoader ? (
                                <div
                                  className="spinner-border text-success"
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>
                              ) : (
                                "No data available"
                              )}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            <table
              className="table table-striped mt-3 "
              style={{ display: "none" }}
              ref={tableEmpSummaryModel}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th style={{ textAlign: "center" }}>Due Month</th>
                  <th style={{ textAlign: "center" }}>Due Case</th>
                  <th style={{ textAlign: "center" }}>Due</th>
                  <th style={{ textAlign: "center" }}>Today Collection</th>
                  <th style={{ textAlign: "center" }}>Collection Count</th>
                  <th style={{ textAlign: "center" }}>Collection Amt</th>
                  <th style={{ textAlign: "center" }}>Outstanding Count</th>
                  <th style={{ textAlign: "center" }}>Outstanding Amount</th>
                  <th style={{ textAlign: "center" }}>Unpaid</th>
                  <th style={{ textAlign: "center" }}>Unpaid Amt</th>
                  <th style={{ textAlign: "center" }}>Late Fee Amount</th>
                </tr>
              </thead>
              <tbody>
                {empSummary.length > 0 ? (
                  empSummary.map((item, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>
                      <td style={{ textAlign: "center" }}>{item.due_month}</td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryDueCase", i);
                            setApiKey("getSummaryDueCase");
                          }
                        }}
                      >
                        {item.due_case}
                      </td>
                      <td style={{ textAlign: "center" }}>{item.due}</td>
                      <td style={{ textAlign: "center" }}>
                        {item.todaycollection}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.collectionc}
                      </td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary(
                              "geSummaryCollectionTodayMonth",
                              i
                            );
                            setApiKey("geSummaryCollectionTodayMonth");
                          }
                        }}
                      >
                        {item.coll}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.outstandingcase}
                      </td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.outstandingamount) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryoutstanding", i);
                            setApiKey("getSummaryoutstanding");
                          }
                        }}
                      >
                        {item.outstandingamount}

                        {
                          // Conditionally render the button
                          <>
                            <button
                              className="btn btn-danger w-auto"
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the row click event when button is clicked
                                ManageEmpSummaryPayAmount(
                                  "getSummaryoutstanding",
                                  i,
                                  item?.outstandingamount
                                );
                                setTotalUnpaid(item?.outstandingamount);
                                handlePaymentInterval();
                                setShowMessage(true);
                              }}
                              // disabled={showMessage}
                            >
                              Pay Now
                            </button>
                            {/* {showMessage && (
                              <div className="text-muted mt-1">
                                Make payment after 1 hour
                              </div>
                            )} */}
                          </>
                        }
                      </td>

                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryUnpaid", i);
                            setApiKey("getSummaryUnpaid");
                          }
                        }}
                      >
                        {item.unpaid}
                      </td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.unpaidamount) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryUnpaid", i);
                            setApiKey("getSummaryUnpaid");
                          }
                        }}
                      >
                        {item.unpaidamount}

                        {item.unpaidamount > 0 &&
                          currentDate >= 8 &&
                          currentDate <= endOfMonth && ( // Conditionally render the button
                            <>
                              <button
                                className="btn btn-success text-white py-2 px-4 rounded shadow"
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent row click when "Pay Now" is clicked
                                  ManageEmpSummaryPayAmount(
                                    "getSummaryUnpaid",
                                    i,
                                    item?.unpaidamount
                                  );
                                  setTotalUnpaid(item?.unpaidamount);
                                  setShowMessage(true);
                                  handlePaymentInterval();
                                }}
                                disabled={showMessage}
                              >
                                Pay Now
                              </button>
                              {showMessage && (
                                <div className="text-muted mt-1">
                                  Make payment after 1 hour
                                </div>
                              )}
                            </>
                          )}
                      </td>
                      <td style={{ textAlign: "center" }}>{item?.latefee}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center" }}>
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "No data available"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <table
              className="table table-striped mt-3 "
              style={{ display: "none" }}
              ref={tableEmpOutstanding}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th>Name</th>
                  <th style={{ textAlign: "center" }}>Loan Id</th>
                  <th>Employer Name</th>
                  <th style={{ textAlign: "center" }}>Mobile No</th>

                  {apiKey === "getSummaryDueCase" && (
                    <th style={{ textAlign: "center" }}>Due Date</th>
                  )}
                  {apiKey === "geSummaryCollectionTodayMonth" && (
                    <th style={{ textAlign: "center" }}>Collection Date</th>
                  )}
                  {apiKey === "getSummaryoutstanding" && (
                    <th style={{ textAlign: "center" }}>Outstanding Date</th>
                  )}
                  {apiKey === "getSummaryUnpaid" && (
                    <th style={{ textAlign: "center" }}>Unpaid Date</th>
                  )}

                  {apiKey === "getSummarylatefee" && (
                    <th style={{ textAlign: "center" }}>Late Fee Date</th>
                  )}
                  {apiKey === "getSummaryDueCase" && (
                    <th style={{ textAlign: "center" }}>Due Amount</th>
                  )}
                  {apiKey === "geSummaryCollectionTodayMonth" && (
                    <th style={{ textAlign: "center" }}>Collection Amount</th>
                  )}
                  {apiKey === "getSummaryoutstanding" && (
                    <th style={{ textAlign: "center" }}>Outstanding Amount</th>
                  )}
                  {apiKey === "getSummaryUnpaid" && (
                    <th style={{ textAlign: "center" }}>Unpaid Amount</th>
                  )}
                  {apiKey === "getSummarylatefee" && (
                    <th style={{ textAlign: "center" }}>Late Fee Amount</th>
                  )}
                  {/* 
                          {apiKey === "getSummaryDueCase" && (
                            <th style={{ textAlign: "center" }}>
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                            </th>
                          )} */}
                </tr>
              </thead>
              <tbody>
                {empData.length > 0 ? (
                  empData.map((item, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>

                      <td>{item.name}</td>

                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.loanid) {
                            setLid(item.loanid);
                            setShowSearch(true);
                          }
                        }}
                      >
                        {item.loanid}
                      </td>
                      <td>{item.code}</td>
                      <td style={{ textAlign: "center" }}>{item.mobileno}</td>
                      <td style={{ textAlign: "center" }}>
                        {moment(item.txndate).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ textAlign: "center" }}>{item.amount}</td>

                      {/* {apiKey === "getSummaryDueCase" && (
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="checkbox"
                                    checked={
                                      !!selectedData.find(
                                        (data) => data.loanid === item.loanid
                                      )
                                    }
                                    onChange={() => handleRowSelect(item)}
                                  />
                                </td>
                              )} */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "No data available"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}
export default EmpOutstandingSummary;
